<template>
    <div class="main">
        <transition name="fade" mode="out-in">
            <div class="main-block_photo" v-if="!isSent">
                <div class="main-block_photo_direct">
                    <h1>мы будем знать как к тебе обращаться</h1>
                    <div class="question">
                        <div class="form-row">
                            <div class="form-group">
                                <Input
                                    class="form-group-input"
                                    :inputClass="first_name.inputClass"
                                    :isValid="first_name.required ? first_name.isValid : true"
                                    :validationMessage="first_name.required ? first_name.validationMessage : ''"
                                    :type="first_name.type"
                                    :name="'' + inputIndex"
                                    :label="first_name.label"
                                    :required="first_name.required"
                                    :cleaveOptions="first_name.cleaveOptions"
                                    :labelDescription="first_name.labelDescription"
                                    v-model="first_name.value" />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group">
                                <Input
                                    class="form-group-input"
                                    :inputClass="email.inputClass"
                                    :isValid="email.required ? email.isValid : true"
                                    :validationMessage="email.required ? email.validationMessage : ''"
                                    :type="email.type"
                                    :name="'' + inputIndex"
                                    :label="email.label"
                                    :required="email.required"
                                    :cleaveOptions="email.cleaveOptions"
                                    :labelDescription="email.labelDescription"
                                    v-model="email.value" />
                            </div>
                        </div>
                    </div>
                    <div class="title">Для тебя выбрано 3 вопроса:</div>
                    <div class="question" v-for="(block, index) in blocks" :key="index">
                        <div class="question_block">
                            <div class="question_block_title">
                                <div class="question_block_title_rectangle">
                                    <img v-lazy-load data-src="~/assets/img/svg/rectangle.svg" alt="" />
                                    <p class="text_11">{{ block.number }}</p>
                                </div>
                                <h2>{{ block.title }}</h2>
                            </div>
                            <div class="question_block_row">
                                <div class="question_block_row_input" v-for="(name, i) in block.checkboxes" :key="i">
                                    <label class="checkbox-container" :for="`checkbox-${index}-${i}`">
                                        <input
                                            type="radio"
                                            :id="`checkbox-${index}-${i}`"
                                            :name="block.number"
                                            :value="name"
                                            v-model="block.value"
                                            class="checkbox" />
                                        <span class="checkmark_text">{{ name }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button
                        :disabled="!isAllowSend"
                        class="question_block-button button button--dark button--large carrot-order-button"
                        :class="!isAllowSend ? 'button--disabled' : ''"
                        @click="sendData()">
                        отправить
                    </button>
                    <div class="text_9">
                        <span class="color-text_2">нажимая на кнопку «отправить», я принимаю</span>
                        <a href="/dokumenty/soglashenie-ob-obrabotke-persnonalnyh-dannyh/" class="">
                            условия публичной оферты и политики конфиденциальности
                        </a>
                    </div>
                </div>
                <img class="main-block_photo_img" v-lazy-load data-src="~/assets/img/question.png" alt="" />
            </div>
            <div class="main-block_photo" v-else>
                <div class="main-block_photo_direct main-block_photo_direct-sent">
                    <p>
                        на самом деле, нам абсолютно всё равно, как ты себя вел в этом году — это никак не влияет на
                        нашу дружбу и мы ценим тебя таким, какой ты есть. ты в любом случае заслуживаешь подарок в новый
                        год — ожидай свой и от нас
                    </p>
                    <div class="main-block_photo_direct-sent-rehash">
                        p.p.s. we rehash a norm <img v-lazy-load :data-src="require('@/assets/img/svg/check.svg').default" alt="" />
                    </div>
                    <NuxtLink
                        class="question_block-button button button--dark button--large carrot-order-button"
                        to="/">
                        на главную
                    </NuxtLink>
                </div>
                <img class="main-block_photo_img" v-lazy-load data-src="~/assets/img/agenderagent.png" alt="" />
            </div>
            <div class="second_row">
                <div class="second_row_box">
                    <p style="">скидка 5% и доступ в сообщество post post scriptum</p>
                    <p class="main_text">подпишись на рассылку и получай наши новости раньше других</p>
                </div>
                <div class="second_row_box">
                    <div class="second_row_box_in">
                        <input name="email" class="second_row_box_input" placeholder="эл.почта" />
                        <button class="text_11">подписаться</button>
                    </div>
                    <p class="main_text text_9">
                        нажимая на кнопку «подписаться», ты даёшь согласие на обработку персональных данных и получение
                        информационной рассылки
                    </p>
                </div>
                <div class="second_row_icon">
                    <div class="second_row_icon_box">
                        <img v-lazy-load data-src="../assets/img/svg/VK.svg" alt="" />
                        <p>комьюнити во вконтакте</p>
                    </div>
                    <div class="second_row_icon_box">
                        <img v-lazy-load data-src="../assets/img/svg/telegram.svg" alt="" />
                        <p>комьюнити в telegram</p>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import Input from "~/components/form/Input";

export default {
    name: "FourPps",
    components: {
        Input,
    },
    data() {
        return {
            first_name: {
                label: this.$i18n.t("yr_name"),
                required: true,
                isValid: true,
                validationMessage: "",
                value: "",
                type: "text",
            },
            email: {
                label: this.$i18n.t("email"),
                required: true,
                isValid: true,
                validationMessage: "",
                value: "",
                type: "email",
            },
            isSent: false,
            blocks: [
                {
                    title: "как ты вел себя в этом году?",
                    name: "behavior",
                    checkboxes: ["хорошо", "плохо", "по настроению"],
                    value: null,
                    number: 1,
                },
                {
                    title: "какая твоя самая любимая студия p.p.s.?",
                    name: "favourite-studio",
                    checkboxes: ["известия", "авиапарк ", "цветной", "атриум", "онлайн", "“рио” ленинский"],
                    value: null,
                    number: 2,
                },
                {
                    title: "в твоем гардеробе уже есть айтемы p.p.s?",
                    name: "items",
                    checkboxes: ["да", "нет", "более 2-х вещей"],
                    value: null,
                    number: 3,
                },
            ],
        };
    },
    computed: {
        isAllowSend() {
            let selected = 0;
            this.blocks.forEach((block) => {
                if (block.value) selected++;
            });
            return selected === this.blocks.length && this.first_name.value;
        },
    },
    methods: {
        resetForm() {
            this.first_name.isValid = true;
            this.first_name.validationMessage = "";
        },
        async sendData() {
            this.resetForm();
            try {
                const formData = {
                    first_name: this.first_name.value,
                    email: this.email.value,
                    behavior: this.blocks[0].value,
                    favourite_studio: this.blocks[1].value,
                    items: this.blocks[2].value,
                };

                await this.$axios.post("/api/forms/4pps/create", formData);

                this.isSent = true;
                window.scrollTo(0, 0);
            } catch (error) {
                let data = error.response.data.error;
                for (let key in data) {
                    this[key].validationMessage = data[key][0];
                    this[key].isValid = false;
                }
            }
        },
    },

    watch: {
        "message.isValid": function (value) {
            if (!value) {
                this.message.validationMessage = "поле обязательно к заполнению";
            } else {
                this.message.validationMessage = "";
            }
        },
    },
};
</script>

<style lang="less" scoped>
.form {
    padding: 40px 30px;
    position: relative;
    display: flex;
    justify-content: center;
    height: 59.5vh;
    min-height: 70vh;
    letter-spacing: 0.16em;

    &-row:last-child .form-group {
        margin-bottom: 40px;
    }

    .rules {
        margin-top: 40px;
        color: #a6a6a6;
        letter-spacing: 0.16em;
        font-size: 11px;
        a {
            color: black;
        }
    }
}

@media screen and (max-width: 751px) {
    .form {
        margin-bottom: 37px;
        position: relative;
        display: flex;
        justify-content: center;
        padding: 20px;
    }
}

.form-row {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

@media screen and (max-width: 751px) {
    .form-group {
        display: flex;
        flex-direction: column;
    }
}

.form-group-input {
    margin-left: 0;
    margin-top: 30px;
    width: 100%;
}

textarea {
    background: none;
    border: 1px solid @border2;
    outline: none;
    padding: 16px 24px;
    height: 148px;
    min-width: 100%;
    margin-top: 35px;
    margin-bottom: 0;
    font: inherit;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0.16em;
    resize: none;
}

@media screen and (max-width: 751px) {
    textarea {
        margin-left: 0px;
    }
}

p {
    color: #a6a6a6;
    margin-top: 10px;
}

b {
    color: rgba(0, 0, 0, 0.99);
}

.button {
    width: 300px;
    margin: 0 auto;
    margin-top: 30px;
    @media @sm {
        width: 100%;
    }
    &:focus {
        color: #fff;
    }
}

h1,
.title {
    font-size: 16px;
}

h2 {
    font-size: 13px;
}

.main {
    letter-spacing: 0.16rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    &_text {
        color: #a6a6a6;
    }
}
.second_row {
    font-size: 11px;
    margin-top: 35px;
    width: 100%;
    height: 279px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 30px;
    &_icon {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 35px;
        &_box {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 5px;
            img {
                width: 16px;
                height: 16px;
            }
        }
    }
    &_box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        font-size: 11px;
        &_in {
            display: flex;
            width: 100%;
            justify-content: center;
            margin-bottom: 4px;
            button {
                width: 100%;
                max-width: 119px;
                background-color: transparent;
                border: @border2 solid 1px;
                padding: 0 15px;
            }
        }
        &_input {
            padding: 10px;
            border: @border2 solid 1px;
            background-color: #f9f9f9;
            width: 100%;
            max-width: 630px;
            height: 40px;

            &::placeholder {
                letter-spacing: 0.16rem;
                color: #000;
                font-size: 11px;
            }
        }
        p {
            margin: 4px 0;
        }
    }
}

.main-block_photo {
    display: grid;
    grid-template-columns: repeat(2, 50%);
    min-height: 40vh;
    background-color: #f9f9f9;
    &_img {
        max-width: 100%;
        min-height: 25vh;
        position: relative;
        @media (max-width: 920px) {
        }
    }
    &_direct {
        padding: 40px 32px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @media (max-width: 920px) {
            padding: 40px 18px;
        }

        &-sent {
            gap: 40px;

            p {
                font-size: 19px;
                line-height: 140%;
                color: #7b7b7b;
                @media (max-width: 920px) {
                    font-size: 13px;
                }
            }

            &-rehash {
                display: flex;
                justify-content: flex-end;
                font-size: 17px;
                text-align: right;

                & img {
                    margin-left: 10px;
                }
            }
        }
    }

    @media (max-width: 920px) {
        display: block;
    }
}

.question {
    display: flex;
    flex-direction: column;
    margin: 20px 0;

    &_block {
        display: flex;
        flex-direction: column;
        gap: 20px;
        &-button {
            margin-bottom: 16px;
        }
        &_title {
            display: flex;
            align-items: center;
            gap: 16px;
            &_rectangle {
                flex-shrink: 0;
                position: relative;
                color: #fff;

                img {
                    width: 26px;
                }

                p {
                    position: absolute;
                    color: #fff;
                    bottom: 4px;
                    left: 10px;
                }
            }
        }

        &_row {
            padding: 32px 40px;
            display: grid;
            grid-template-columns: repeat(4, 24%);
            background-color: #ffffff;
            border: @border2 1px solid;
            gap: 10px;
            justify-content: center;
            align-items: center;
            &_input {
                padding: 15px 0;
                width: 100%;
            }
            @media (max-width: 1200px) {
                padding: 28px 40px;
                display: block;
            }
        }
    }
    .checkbox {
        margin-right: 16px;
        width: 16px;
        height: 16px;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }
    .checkmark_text {
        font-size: 11px;
        position: relative;
        white-space: nowrap;
        margin-left: 5px;
        text-overflow: ellipsis;
    }
    .checkbox-container {
        display: flex;
        cursor: pointer;
        align-items: center;
    }
    input[type="radio"] {
        cursor: pointer;
        border: 1px solid black;
    }
    input[type="radio"]:before {
        position: relative;
        top: 7px;
        left: 50%;
        content: "";
        display: inline-block;
        width: 16px;
        height: 16px;
        margin-right: 5px;
        border-radius: 3px;
        color: #333333;
        transform: translate(-50%, -50%) scale(0);
        background-image: url("../assets/img/svg/check.svg");
        background-repeat: no-repeat;
    }

    input[type="radio"]:checked:before {
        transform: translate(-50%, -50%) scale(1);
    }

    input[type="radio"]:before {
        background-size: 100% 100%;
        background-position: center;
        transition: 0.2s ease-in;
    }
}
</style>
